import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

export const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: '/demo',
    name: 'MobileDemo',
    meta: { title: '移动端demo页面' },
    component: () => import('@/mobile/views/demo/index.vue')
  },
  {
    path: '/businessCard',
    name: 'MobileBusinessCard',
    meta: { title: '销售名片' },
    component: () => import('@/mobile/views/businessCard/index.vue')
  },
  {
    path: '/activity',
    name: 'MobileActivity',
    meta: { title: '扫码活动' },
    component: () => import('@/mobile/views/activity/index.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory('/mobile/'),
  routes: constantRoutes
})

export default router
